import { render, staticRenderFns } from "./OperaBannerWindow.vue?vue&type=template&id=96bf7e42&scoped=true&"
import script from "./OperaBannerWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBannerWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaBannerWindow.vue?vue&type=style&index=0&id=96bf7e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bf7e42",
  null
  
)

export default component.exports